// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  font-family: "DM Sans", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-color: rgb(244, 244, 244);
}

/* Force form elements to inherit font (they don't by default in browsers) */
button,
input,
select,
textarea {
  font-family: inherit;
}

/* Ensure all MUI buttons use DM Sans font */
.MuiButton-root,
.MuiButtonBase-root,
.MuiIconButton-root,
.MuiToggleButton-root,
.MuiFab-root {
  font-family: "DM Sans", sans-serif !important;
}

.component-title {
  font-size: 24px;
  color: #4b14b9
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,kCAAkC;EAClC,mCAAmC;EACnC,kCAAkC;EAClC,oCAAoC;AACtC;;AAEA,4EAA4E;AAC5E;;;;EAIE,oBAAoB;AACtB;;AAEA,4CAA4C;AAC5C;;;;;EAKE,6CAA6C;AAC/C;;AAEA;EACE,eAAe;EACf;AACF","sourcesContent":["body {\r\n  margin: 0;\r\n  font-family: \"DM Sans\", sans-serif;\r\n  -webkit-font-smoothing: antialiased;\r\n  -moz-osx-font-smoothing: grayscale;\r\n  background-color: rgb(244, 244, 244);\r\n}\r\n\r\n/* Force form elements to inherit font (they don't by default in browsers) */\r\nbutton,\r\ninput,\r\nselect,\r\ntextarea {\r\n  font-family: inherit;\r\n}\r\n\r\n/* Ensure all MUI buttons use DM Sans font */\r\n.MuiButton-root,\r\n.MuiButtonBase-root,\r\n.MuiIconButton-root,\r\n.MuiToggleButton-root,\r\n.MuiFab-root {\r\n  font-family: \"DM Sans\", sans-serif !important;\r\n}\r\n\r\n.component-title {\r\n  font-size: 24px;\r\n  color: #4b14b9\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
